export const ORDER_COLUMNS = [
    { id: "id", label: "#", width: "10px" },
    { id: "name", label: "الاسم", width: "100px" },
    { id: "vendor", label: "المطعم", width: "80px" },
    { id: "status", label: "الحاله", width: "150px" },
    { id: "delivery", label: "السائق", width: "100px" },
    { id: "type", label: "نوع الطلب", width: "100px" },
    { id: "prepTime", label: "وقت التحضير", width: "100px" },
    // THE RED TIMER (admin#40), beside the time it counts down. Live while the
    // order waits for its driver, then gone: the column after it says how the
    // pickup went against the same time.
    {
        id: "prepTimer",
        label: "الوقت المتبقي",
        hint: "يعد تنازليًا من وقت التحضير، ثم بالسالب بالأحمر حتى يستلم السائق الطلب من المطعم",
        width: "110px",
    },
    // THE TWO DURATIONS SAHER ASKED FOR. Beside the prep estimate they are
    // measured against, and before the money, because they read as one story:
    // promised → collected → delivered.
    {
        id: "pickupDelta",
        label: "الاستلام من المطعم",
        hint: "هل استلم السائق الطلب من المطعم قبل انتهاء وقت التحضير أم بعده",
        width: "140px",
    },
    // Two durations that end at the same moment and start at different ones.
    // The first includes the wait at the restaurant; the second is the road
    // only. The labels are the ones the order page uses for the same numbers.
    {
        id: "deliveryTime",
        label: "من الإسناد حتى التسليم",
        hint: "المدة من إسناد الطلب للسائق حتى تسليمه للزبون، ومعها الانتظار في المطعم",
        width: "150px",
        wrap: true,
    },
    {
        id: "roadTime",
        label: "من استلام الطلب من المطعم حتى التسليم",
        hint: "المدة من استلام السائق للطلب من المطعم حتى تسليمه للزبون: وقت الطريق فقط",
        width: "170px",
        wrap: true,
    },
    { id: "area", label: "المنطقة", width: "100px" },
    { id: "shipping", label: "التوصيل (₪)", width: "90px" },
    { id: "total", label: "المجموع (₪)", width: "80px" },
    { id: "isFree", label: "طلب مجاني؟", width: "100px" },
    { id: "createdAt", label: "وقت الانشاء", width: "100px" },
    { id: "deletedForVendor", label: "محذوف للمطعم", width: "80px" },
    { id: "deletedForDelivery", label: "محذوف للسائق", width: "80px" },
    // THE TWO WALLETS, in the same order and with the same naming as the two
    // flags before them: the restaurant, then the driver (admin#41). Each cell
    // is what that wallet holds for the order. Same ids, labels and place on
    // the driver orders page.
    { id: "vendorWallet", label: "محفظة المطعم", width: "110px" },
    { id: "driverWallet", label: "محفظة السائق", width: "140px" },
    { id: "orderRating", label: "التقييم", width: "90px" },
    { id: "actions", label: "الاعدادات", width: "50px" },
];

export const ORDER_COLUMNS_BY_ID = ORDER_COLUMNS.reduce((acc, col) => {
    acc[col.id] = col;
    return acc;
}, {});
